import { Action, createReducer, on } from '@ngrx/store'
import { FETCH_AUTOMATION_PROCESS_LIST_SUCCESS } from '../action/automation-process-register.action'
import {
  AutomationProcessRegisterState,
  initialAutomationRegisterState
} from '../state/automation-process-register.state'

export function automationProcessRegisterReducer(state: AutomationProcessRegisterState, action: Action) {
  return _automationProcessRegisterReducer(state, action)
}

const _automationProcessRegisterReducer = createReducer(
  initialAutomationRegisterState,
  on(FETCH_AUTOMATION_PROCESS_LIST_SUCCESS, (state, { automationRegisterList }) => {
    return {
      ...state,
      automationRegisterList: automationRegisterList
    }
  })
)
